import { Link } from 'react-router';
import { motion } from 'motion/react';
import { Button } from '@mieweb/ui';

interface ComparisonCTAProps {
  competitorName: string;
}

export function ComparisonCTA({ competitorName }: ComparisonCTAProps) {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto text-center"
      >
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">
          Ready to switch from {competitorName}?
        </h2>
        <p className="text-lg text-slate-600 dark:text-neutral-400 mb-4">
          Start collecting feedback in minutes with Pollenate&apos;s free tier.
          No credit card required.
        </p>
        <p className="text-sm text-slate-500 dark:text-neutral-500 mb-8">
          5,000 events/month free &bull; All widget types included &bull; Unlimited team members
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/login?mode=signup">
            <Button size="lg">Start Free Today</Button>
          </Link>
          <Link to="/docs">
            <Button variant="outline" size="lg">Read the Docs</Button>
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
